import { useQuery } from "@tanstack/react-query";
import { getPermissionGroupsApi } from "../api/permissionGroupsApi";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const permissionGroupKeys = {
  all: (chainId: ChainId | null) => ["chains", chainId, "permissionGroups"],
};

export const useGetPermissionGroupsQuery = (chainId: ChainId | null) => {
  return useQuery({
    queryKey: permissionGroupKeys.all(chainId),
    queryFn: () => getPermissionGroupsApi(chainId!),
    enabled: !!chainId,
  });
};
